"use client";

import { BUSINESS_PREFERENCES, PRIVAT_PREFERENCES } from "@/features/quote/shared/quote-config";
import { CheckRow } from "@/features/quote/ui/CheckRow";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useWizard } from "@/features/quote/ui/wizard-context";

export function PreferencesStep() {
  const { state, toggle, goToStep, step, isBusiness } = useWizard();

  return (
    <section>
      <StepHeading
        title={isBusiness ? "Særlige krav?" : "Særlige ønsker?"}
        body="Valgfrit. Marker det der er relevant - det hjælper os med at finde det rigtige firma."
      />
      <CheckRow
        options={isBusiness ? BUSINESS_PREFERENCES : PRIVAT_PREFERENCES}
        values={state.preferences}
        onToggle={(v) => toggle("preferences", v)}
      />
      <StepNav
        onBack={() => goToStep(step - 1)}
        onNext={() => goToStep(step + 1)}
        nextEnabled
        nextLabel="Næste →"
      />
    </section>
  );
}
